import React, { useEffect, useReducer, useState } from 'react';
import GameManager from '../cvp-webgames-core/GameManager';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import { constants } from '../misc/constants';
import BeginScenarioUI from './ui/BeginScenarioUI';
import BadgingProgressUI from './ui/BadgingProgressUI';
import YouRespondUI from './ui/YouRespondUI'
import DirectionsUI from './ui/DirectionsUI';
import EndLevelUI from './ui/EndLevelUI';
import HeaderUI from './ui/HeaderUI';
import MedicalDispenserUI from './ui/MedicalDispenserUI';
import NurseStationComputerSingleQuestionUI from './ui/NurseStationComputerSingleQuestionUI';
import NurseStationComputerUI from './ui/NurseStationComputerUI';
import ResumeUI from './ui/ResumeUI';
import StaffingPlanUI from './ui/StaffingPlanUI';
import AARUI from './ui/AARUI';
import ReturnToMainMenuUI from './ui/ReturnToMainMenuUI';
import './UIOverlay.css';
import SplashScreenUI from './ui/SplashScreenUI';
import FeedbackUI from './ui/FeedbackUI';
import DelegateUI from './ui/DelegateUI';
import KnowledgeCheckUI from './ui/KnowledgeCheckUI';
import ConfirmAlert from './ui/ConfirmAlert';
import { globals } from '../misc/globals';
import { getSaveData } from '../misc/tools';
import SampleScenarioUI from './ui/SampleScenarioUI';

import LoadedAssetsUI from '../cvp-webgames-core/Components/general/react/LoadedAssetsUI';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import Tools from '../cvp-webgames-core/Misc/Tools';
import ReactCaption from '../cvp-webgames-core/Components/general/react/ReactCaption';
import { ClosedCaptionManager } from '../cvp-webgames-core/ClosedCaptionManager';
var showScoreForCurrentBadge = false;
 
const debugData = [
	{
		title: 'Best',
		color: 'green'
	},
	{
		title: 'Zero',
		color: 'white'
	},
	{
		title: 'Ok',
		color: 'gold'
	},
	{
		title: 'Worst',
		color: 'red'
	},
	{
		title: 'Worst2',
		color: 'rgb(255, 100, 100)'
	}
]

const reducer = (state: any, action: any) => {
	return state;
};
var ccManager: ClosedCaptionManager = null;

//globals.showDebugForComponents = Tools.isLocalhost();

const UIOverlay = (props: any) => {
	const [uisRegistered, setUisRegistered] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);
	const [enableDebugMenu, setEnableDebugMenu] = useState(globals.showDebugForComponents);
	const [state, dispatch] = useReducer(reducer, {
		uiProps: null,
		gameManager: props.gameManager
	});

	var isDisplayingHeader = false;

	(window as any).setCCManager = (ccM: any) => {
		ccManager = ccM;
		(window as any).forceUpdateInternalCCComp(); 
		// if((window as any).onCaptionsChanged) {
		// 	(window as any).onCaptionsChanged();
		// }
	}

	const getScoreForCurrentScenario = () => {
		var savedData = props.gameManager.customData.saveData;
		var id = parseInt(props.scenarioId[props.scenarioId.length - 1]) - 1;
		var scenario = savedData.scenarios[id];

		var result: {
			key: string,
			current?: number,
			max: number
		}[] = [];

		for(var indx = 0; indx < scenario.badges.length; indx++) {
			result.push({
				key: scenario.badges[indx].key,
				max: scenario.badges[indx].maxPoints,
				current: (scenario as any).scores && (scenario as any).scores.length > indx ? (scenario as any).scores[indx] : 0
			})
		}

		return result;
	}


	useEffect(() => {
		$(window).resize();

		if(uisRegistered) {
			return;
		}

		setInterval(() => {
			globals.queryMemory = true;
		}, 2000);

		setUisRegistered(true);

		var uiManager = props.gameManager.UiManager as JsxUIManager;

		uiManager.registerUI(constants.uiNames.HeaderUI, {
			renderMethod: (instance: any) => {
				isDisplayingHeader = true;
				return (
					<div id={instance.id}>
						<HeaderUI id={'header-container-ui-root'} dispatch={dispatch} key={instance.id} parameters={{...instance.parameters, updateWindow: props.updateWindow}}></HeaderUI>

						<ReactCaption
							currentCaption={ccManager.currentCaption}
							isPaused={ccManager.isPaused}
						></ReactCaption>
					</div>
				)
			},
		}, constants.uiTags.Hud);

		uiManager.registerUI(constants.uiNames.SplashScreenUI, {
			renderMethod: (instance: any) => {
				return <SplashScreenUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SplashScreenUI>
			}
		});

		uiManager.registerUI(constants.uiNames.BeginScenarioUI, {
			renderMethod: (instance: any) => {
				return (
					<div id={instance.id}>
						<ReactCaption
							currentCaption={ccManager.currentCaption}
							isPaused={ccManager.isPaused}
						></ReactCaption>
						<BeginScenarioUI id={'begin-scenario-ui-container-ui-root'} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></BeginScenarioUI>

						
					</div>
					)
			}
		});
		
		uiManager.registerUI(constants.uiNames.YouRespondUI, {
			renderMethod: (instance: any) => {
				return <YouRespondUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></YouRespondUI>
			}
		}, constants.uiTags.youRespond);

		uiManager.registerUI(constants.uiNames.DirectionsUI, {
			renderMethod: (instance: any) => {
				return <DirectionsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></DirectionsUI>
			}
		});

		uiManager.registerUI(constants.uiNames.FeedbackUI, {
			renderMethod: (instance: any) => {
				return <FeedbackUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></FeedbackUI>
			}
		});

		uiManager.registerUI(constants.uiNames.NurseStationComputerUI, {
			renderMethod: (instance: any) => {
				return <NurseStationComputerUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></NurseStationComputerUI>
			}
		});

		uiManager.registerUI(constants.uiNames.NurseStationComputerSingleQuestionUI, {
			renderMethod: (instance: any) => {
				return <NurseStationComputerSingleQuestionUI id={instance.id} dispatch={dispatch} parameters={instance.parameters}></NurseStationComputerSingleQuestionUI>
			}
		});

		uiManager.registerUI(constants.uiNames.BadgingProgressUI, {
			renderMethod: (instance: any) => {
				return <BadgingProgressUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></BadgingProgressUI>
			}
		});

		uiManager.registerUI(constants.uiNames.MedicalDispenserUI, {
			renderMethod: (instance: any) => {
				return <MedicalDispenserUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></MedicalDispenserUI>
			}
		});

		uiManager.registerUI(constants.uiNames.EndLevelUI, {
			renderMethod: (instance: any) => {
				return <EndLevelUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={{...instance.parameters, updateWindow: props.updateWindow}}></EndLevelUI>
			}
		});

		uiManager.registerUI(constants.uiNames.AARUI, {
			renderMethod: (instance: any) => {
				return <AARUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></AARUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ResumeUI, {
			renderMethod: (instance: any) => {
				return <ResumeUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ResumeUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ReturnToMainMenuUI, {
			renderMethod: (instance: any) => {
				return <ReturnToMainMenuUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ReturnToMainMenuUI>
			}
		});

		uiManager.registerUI(constants.uiNames.StaffingPlanUI, {
			renderMethod: (instance: any) => {
				return <StaffingPlanUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></StaffingPlanUI>
			}
		});

		uiManager.registerUI(constants.uiNames.DelegateUI, {
			renderMethod: (instance: any) => {
				return <DelegateUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></DelegateUI>
			}
		});

		uiManager.registerUI(constants.uiNames.KnowledgeCheckUI, {
			renderMethod: (instance: any) => {
				return <KnowledgeCheckUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></KnowledgeCheckUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ConfirmAlertUI, {
			renderMethod: (instance: any) => {
				return <ConfirmAlert id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ConfirmAlert>
			}
		});

		uiManager.registerUI(constants.uiNames.SampleScenarioUI, {
			renderMethod: (instance: any) => {
				return <SampleScenarioUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SampleScenarioUI>
			}
		});
	}, [state]);
	return state.gameManager && state.gameManager.environment && state.gameManager.environment.isReady ? (
		<div className="in-game-overlay-container in-game-ui-container ui-container-root">
			{props.gameManager.UiManager.render()}
			{props.gameManager.SoundManager.render()}
			<InternalCaptionComp></InternalCaptionComp>
			

			{enableDebugMenu ? (
				<button tabIndex={-1} style={{
					position: 'absolute',
					bottom: '10px',
					left: '10px',
					color: 'white',
					pointerEvents: 'all',
					zIndex: 100
				}} onClick={() => {
					globals.showDebugForComponents = !globals.showDebugForComponents;
					props.forceUpdate();
				}}>
					{(globals.showDebugForComponents ? 'Hide' : 'Show') + ' Debug Tools'}
				</button>
				// null
			) : (null)}

			{globals.showDebugForComponents ? (
				<button tabIndex={-1} style={{
					position: 'absolute',
					top: '30px',
					left: '50%',
					transform: 'translate (-50%, 0)',
					color: 'white',
					pointerEvents: 'all',
					zIndex: 100
				}} onClick={() => {	
					showScoreForCurrentBadge = !showScoreForCurrentBadge;
					props.forceUpdate();
				}}>
					{(showScoreForCurrentBadge ? 'Hide ' : 'Show ') + 'Score For Current Badge'}
				</button>
			) : (null)}

			{globals.showDebugForComponents && showScoreForCurrentBadge ? ( 
				<div tabIndex={-1} style={{
					position: 'absolute',
					bottom: '10px',
					right: '10px',
						zIndex: 100
				}}>
					{getScoreForCurrentScenario().map(score => {
						return (<p className="title-font" style={{
							color: 'white'
						}}>{score.key + ': ' + score.current + '/' + score.max }</p>)
					})}
				</div>) : (null)}


			{globals.showDebugForComponents && globals.showDebugAnswerTypes ? (
				<div tabIndex={-1} style={{
					position: 'absolute',
					top: '84px',
					left: '160px',
					pointerEvents: 'all',
					zIndex: 100
				}}>
					<div style={{
						position: 'absolute',
						top: '-125ppx',
						width: '100px',
						height: '125px',
						pointerEvents: 'none',
						backgroundColor: 'rgba(0,0,0, 0.5)'
					}}>
						{debugData.map((item) => {
							return (
								<div style={{
									width: '100%',
									height: '25px',
								}}>
									<div style={{
										width: '25px',
										height: '25px',
										backgroundColor: item.color,
										float: 'left'
									}}>
									</div>
									<p style={{
										float: 'right',
										margin: 0
									}}>{item.title}</p>
								</div>
							)
						})}
					</div>
				</div>
			) : (null)}


			{globals.showDebugForComponents ? (
				<div tabIndex={-1} style={{
					position: 'absolute',
					top: '50px',
					left: '50%',
					transform: 'translate (-50%, 0)',
					pointerEvents: 'all',
					zIndex: 100
				}}>
					<button tabIndex={-1} style={{
						color: 'white',
					}}onClick={() => {	
						globals.showDebugAnswerTypes = !globals.showDebugAnswerTypes;
						props.forceUpdate();
					}}>
						{(globals.showDebugAnswerTypes ? 'Hide' : 'Show') + ' Answers'}
					</button>
				</div>
			) : (null)}

			{globals.showDebugForComponents ? (
				<div tabIndex={-1} style={{
					position: 'absolute',
					bottom: '30px',
					left: '20px',
					pointerEvents: 'all',
					zIndex: 1000
				}}>
					<LoadedAssetsUI memory={globals.memory} assets={VideoEnvironment.videoAssets}></LoadedAssetsUI>
				</div>
			) : (null)}

			<audio id='correct-audio' src="./assets/audio/general/Correct_Answer.mp3" playsInline={true} controls={false}></audio>
			<audio id='wrong-audio' src="./assets/audio/general/Wrong_Answer.mp3" playsInline={true} controls={false}></audio>

			<audio id='button-click' src="./assets/audio/general/Default_ButtonClick.mp3" playsInline={true} controls={false}></audio>
			<audio id='button-rollover' src="./assets/audio/general/Default_ButtonRollover.mp3" playsInline={true} controls={false}></audio>
		</div>
	) : (null);
};

export default UIOverlay;

const InternalCaptionComp = () => {
	const [forceUpdate, setForceUpdate] = useState(false);

	(window as any).forceUpdateInternalCCComp = () => {
		setForceUpdate(!forceUpdate);
	}

	return (
		<div>
			{ccManager && ccManager.currentCaption && !ccManager.isPaused && <div className="caption-container">
					{(window as any).CCEnabled &&
						<div className="caption-block">
							<p tabIndex={0} className="caption-paragraph" dangerouslySetInnerHTML={{__html: ccManager.currentCaption}}>
							</p>
						</div>
					}
				</div>
				}

		</div>
	);

};